import React from 'react';
import PricingPlanContainer from './pricing-plan.styles';

const PricingPlan = ({ name, price, features }) => {
    return (
        <PricingPlanContainer>
            <div className="head">
                <h3>{name}</h3>
                <span>{price}</span>
            </div>
            <ul>
                {features.map(({ feature, id }) => (
                    <li key={id}>{feature}</li>
                ))}
            </ul>
            <div className="foot">
                <a href="#">Buy Now</a>
            </div>
        </PricingPlanContainer>
    );
};

export default PricingPlan;
